/** @jsx jsx */
/** @jsxRuntime classic */
import { jsx } from '@emotion/react';
import React from 'react';
import Icon, { IconName } from '../icons/Icon';
import useTheme from '../style/useTheme';
import { noop } from '../utils';
import InteractiveDiv from '../InteractiveDiv/InteractiveDiv';
import { ColorResolveOptions } from '../style/colors';

const BaseInputIcon = ({
  icon,
  onClick,
  'aria-hidden': ariaHidden,
  'aria-label': ariaLabel,
  color,
  size = 24,
}: {
  icon?: IconName;
  onClick?: () => void;
  'aria-hidden'?: boolean;
  'aria-label'?: string;
  color?: ColorResolveOptions;
  size?: number;
}): JSX.Element => {
  const { theme } = useTheme();
  if (!icon) return <React.Fragment />;

  const RenderedComponent = onClick ? InteractiveDiv : 'div';

  const inputIconColor: ColorResolveOptions = {
    type: 'component',
    value: theme.components.input.default.iconColor,
  };

  return (
    <RenderedComponent
      css={{
        display: 'flex',
        alignContent: 'center',
        alignItems: 'center',
        margin: '0 4px',
        ...(onClick && { cursor: 'pointer' }),
      }}
      onClick={onClick || noop}
      aria-hidden={ariaHidden}
      aria-label={ariaLabel}
    >
      <Icon icon={icon} size={size} color={color || inputIconColor} />
    </RenderedComponent>
  );
};

export default BaseInputIcon;
